import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, tap, switchMap, firstValueFrom } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { CriarRecadastramentoResponseDto } from '../models/Criar.Recadastramento.Response.Dto';
import { IniciarRecadastramentoRequestDto } from '../models/Iniciar.Recadastramento.Request.Dto';
import { IniciarRecadastramentoResponseDto } from '../models/Iniciar.Recadastramento.Response.Dto';
import { FinalizarRecadastramentoRequestDto } from '../models/Finalizar.Recadastramento.Request.Dto';
import { FinalizarRecadastramentoResponseDto } from '../models/Finalizar.Recadastramento.Response.Dto';
import { IniciarCadastroResponseDto } from '../models/Iniciar.Cadastro.Response.Dto';
import { FinalizarCadastroRequestDto } from '../models/Finalizar.Cadastro.Request.Dto';
import { FinalizarCadastroResponseDto } from '../models/Finalizar.Cadastro.Response.Dto';

@Injectable({ providedIn: 'root' })
export class formularioService {
  constructor(private httpClient: HttpClient) { }

  consultarConsumidormatricula(matricula: string): Observable<CriarRecadastramentoResponseDto> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const url = `${environment.cedaeapp}/buscasdetalhadas/recente-por-matricula/${matricula}`;

    return this.httpClient.get<CriarRecadastramentoResponseDto>(url, { headers }).pipe(
      tap(response => console.log('✅ cadastro:', response)),
      catchError(err => {
        console.error('❌ Erro ao consultar consumidor:', err);
        throw err;
      })
    );
  }

  consultarConsumidorPorId(idjuncao: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const url = `${environment.cedaeapp}/buscasdetalhadas/recente-por-idjuncao/${idjuncao}`;

    return this.httpClient.get<any>(url, { headers }).pipe(
      tap(response => console.log('✅ consumidor:', response)),
      catchError(err => {
        console.error('❌ Erro ao consultar consumidor:', err);
        throw err;
      })
    );
  }

  adicionarCadastro(cadastroId: string, usuarioId: string, formData?: any): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    console.log('ℹ️ Usando cadastroId existente:', cadastroId);

    let requestData = new FormData();
    requestData.append('UsuarioId', usuarioId);

    if (formData && !(formData instanceof FormData)) {
      for (const [key, value] of Object.entries(formData)) {
        if (value !== null && value !== undefined) {
          if (key === 'endereco' && typeof value === 'object') {
            const endereco = value as any;
            for (const [endKey, endValue] of Object.entries(endereco)) {
              if (endValue !== null && endValue !== undefined) {
                requestData.append(`Endereco.${endKey.charAt(0).toUpperCase() + endKey.slice(1)}`, String(endValue));
              }
            }
          } else if (key !== 'fotos' && key !== 'fotosDocumento') {
            requestData.append(key.charAt(0).toUpperCase() + key.slice(1), String(value));
          }
        }
      }
    } else if (formData instanceof FormData) {
      const formEntries = Array.from(formData.entries());
      for (const [key, value] of formEntries) {
        if (!key.includes('Fotos') && !key.toLowerCase().includes('foto')) {
          requestData.append(key, value as string | Blob);
        }
      }

      if (!requestData.has('UsuarioId')) {
        requestData.append('UsuarioId', usuarioId);
      }
    }

    const url = `${environment.cedaeapp}/cadastro/adicionarcadastro/${cadastroId}`;

    return this.httpClient.post<any>(url, requestData, { headers }).pipe(
      tap(async (response) => {
        console.log('✅ Cadastro adicionado com sucesso:', response);

        // Upload assinatura do vistoriador
        const assinaturaVistFile = formData.get('AssinaturaVistoriante') as File;
        if (assinaturaVistFile) {
          await firstValueFrom(this.uploadAssinaturaVistoriante(cadastroId, assinaturaVistFile));
          console.log('✅ Assinatura do vistoriador enviada com sucesso');
        }

        // Upload assinatura do acompanhante
        const assinaturaAcompFile = formData.get('AssinaturaAcompanhante') as File;
        if (assinaturaAcompFile) {
          await firstValueFrom(this.uploadAssinaturaAcompanhante(cadastroId, assinaturaAcompFile));
          console.log('✅ Assinatura do acompanhante enviada com sucesso');
        }
      }),
      catchError(err => {
        console.error('❌ Erro ao adicionar cadastro:', err);
        throw err;
      })
    );
  }

  uploadAssinaturaVistoriante(cadastroId: string, file: File): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
      // Não inclua 'Content-Type'! O Angular define isso automaticamente para multipart.
    });

    const formData = new FormData();
    formData.append('file', file); // O nome do campo deve ser exatamente 'file' conforme o Swagger

    const url = `${environment.cedaeapp}/assinaturas/vistoriante/${cadastroId}/upload`;

    return this.httpClient.post<any>(url, formData, { headers });
  }

  uploadAssinaturaAcompanhante(cadastroId: string, file: File): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const formData = new FormData();
    formData.append('file', file);

    // Fix typo in the endpoint URL
    const url = `${environment.cedaeapp}/assinaturas/acompanhante/${cadastroId}/upload`;

    return this.httpClient.post<any>(url, formData, { headers });
  }

  adicionarFotos(cadastroId: string, foto: File): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const formData = new FormData();
    formData.append('arquivos', foto); // nome correto

    const url = `${environment.cedaeapp}/fotos/${cadastroId}/fotos`;

    return this.httpClient.post<any>(url, formData, { headers }).pipe(
      tap(response => console.log('✅ Foto adicionada com sucesso:', response)),
      catchError(err => {
        console.error('❌ Erro ao adicionar foto:', err);
        throw err;
      })
    );
  }

  buscarFotosPorCadastro(cadastroId: string): Observable<{ fotoId: string; url: string }[]> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const url = `${environment.cedaeapp}/fotos/${cadastroId}/fotos`;

    return this.httpClient.get<{ fotoId: string; url: string }[]>(url, { headers }).pipe(
      tap(fotos => console.log('📸 Fotos carregadas:', fotos)),
      catchError(err => {
        console.error('❌ Erro ao buscar fotos:', err);
        throw err;
      })
    );
  }


  enviarFotosDocumentos(cadastroId: string, documentos: File[]): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const formData = new FormData();
    documentos.forEach(doc => formData.append('arquivos', doc));

    const url = `${environment.cedaeapp}/fotos/${cadastroId}/docs`;

    return this.httpClient.post<any>(url, formData, { headers }).pipe(
      tap(response => console.log('✅ Documentos enviados com sucesso:', response)),
      catchError(err => {
        console.error('❌ Erro ao enviar documentos:', err);
        throw err;
      })
    );
  }

  buscarFotosDocumentosPorCadastro(cadastroId: string): Observable<{ fotoDocumentoId: string; url: string }[]> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const url = `${environment.cedaeapp}/fotos/${cadastroId}/docs`;

    return this.httpClient.get<{ fotoDocumentoId: string; url: string }[]>(url, { headers }).pipe(
      tap(documentos => console.log('📄 Documentos carregados:', documentos)),
      catchError(err => {
        console.error('❌ Erro ao buscar documentos:', err);
        throw err;
      })
    );
  }

  excluirFoto(fotoId: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const url = `${environment.cedaeapp}/fotos/foto/${fotoId}`;

    return this.httpClient.delete<any>(url, { headers }).pipe(
      tap(() => console.log('🗑️ Foto excluída com sucesso')),
      catchError(err => {
        console.error('❌ Erro ao excluir foto:', err);
        throw err;
      })
    );
  }

  excluirFotosDocumento(docId: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const url = `${environment.cedaeapp}/fotos/doc/${docId}`;

    return this.httpClient.delete<any>(url, { headers }).pipe(
      tap(() => console.log('🗑️ Documento excluído com sucesso')),
      catchError(err => {
        console.error('❌ Erro ao excluir documento:', err);
        throw err;
      })
    );
  }


  iniciarCadastro(formData: FormData): Observable<IniciarCadastroResponseDto> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const url = `${environment.cedaeapp}/cadastro/iniciarcadastro`;

    return this.httpClient.post<IniciarCadastroResponseDto>(url, formData, { headers }).pipe(
      tap(response => console.log('✅ Cadastro iniciado com sucesso:', response)),
      catchError(err => {
        console.error('❌ Erro ao iniciar cadastro:', err);
        throw err;
      })
    );
  }

  finalizarCadastro(Cadastro: FinalizarCadastroRequestDto): Observable<FinalizarCadastroResponseDto> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const cadastroIdDoStorage = localStorage.getItem('cadastroId');

    if (!Cadastro.cadastroId && !cadastroIdDoStorage) {
      console.error('❌ Erro: Não foi encontrado um cadastroId válido');
      throw new Error('Não foi possível encontrar o ID do cadastro para finalização');
    }

    const cadastroIdFinal = Cadastro.cadastroId || cadastroIdDoStorage as string;


    const formData = new FormData();

    // Aqui o ID deve estar no corpo, não na URL
    formData.append('cadastroId', cadastroIdFinal);
    formData.append('LatitudeFim', Cadastro.latitudeFim);
    formData.append('LongitudeFim', Cadastro.longitudeFim);

    const url = `${environment.cedaeapp}/cadastro/finalizarcadastro/${cadastroIdFinal}`;


    if (!Cadastro.latitudeFim || !Cadastro.longitudeFim) {
      console.warn('⚠️ Coordenadas não disponíveis. Usando valores padrão.');
      formData.set('LatitudeFim', '-22.9068');
      formData.set('LongitudeFim', '-43.1729');
    }

    return this.httpClient.put<FinalizarCadastroResponseDto>(url, formData, { headers }).pipe(
      tap(response => {
        console.log('✅ Cadastro finalizado com sucesso:', response);

        localStorage.removeItem('cadastroId');
        localStorage.removeItem('formData');

        // Recarregar a página após o sucesso
        setTimeout(() => {
          window.location.reload();
        }, 1000); // Pequeno delay para permitir que o usuário veja a mensagem de sucesso
      }),
      catchError(err => {
        console.error('❌ Erro ao finalizar Cadastro:', err);
        throw err;
      })
    );
  }


  finalizarCadastroComFormulario(cadastroId: string, usuarioId: string, formData: any, coords?: { lat: string, lng: string }): Observable<any> {
    const finalizacaoData: FinalizarCadastroRequestDto = {
      cadastroId: cadastroId,
      latitudeFim: coords?.lat || '',
      longitudeFim: coords?.lng || ''
    };

    return this.finalizarCadastro(finalizacaoData).pipe(
      tap(response => {
        console.log('✅ Finalização do cadastro concluída, enviando formulário completo');
      }),
      switchMap(() => this.adicionarCadastro(cadastroId, usuarioId, formData)),
      tap(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
    );
  }

  iniciarRecadastramento(recadastramento: IniciarRecadastramentoRequestDto): Observable<IniciarRecadastramentoResponseDto> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    if (!recadastramento.cadastroId) {
      console.error('❌ Erro: cadastroId é obrigatório para iniciar recadastramento');
      throw new Error('O ID do cadastro é obrigatório para iniciar o recadastramento');
    }

    const formData = new FormData();
    formData.append('UsuarioId', recadastramento.usuarioId);
    formData.append('LatitudeInicio', recadastramento.latitudeInicio);
    formData.append('LongitudeInicio', recadastramento.longitudeInicio);


    const url = `${environment.cedaeapp}/recadastro/iniciar/${recadastramento.cadastroId}`;

    return this.httpClient.post<IniciarRecadastramentoResponseDto>(url, formData, { headers }).pipe(
      tap(response => {
        console.log('✅ Recadastramento iniciado com sucesso:', response);
        localStorage.setItem('recadastramentoAtivo', JSON.stringify({
          cadastroId: recadastramento.cadastroId,
          recadastroId: response.recadastroId, // Salvar o recadastroId recebido na resposta
          dataHoraInicio: response.dataHoraRecadastramento || new Date().toISOString(),
          usuarioId: recadastramento.usuarioId,
          latitudeInicio: recadastramento.latitudeInicio,
          longitudeInicio: recadastramento.longitudeInicio
        }));
      }),
      catchError(err => {
        console.error('❌ Erro ao iniciar recadastramento:', err);
        throw err;
      })
    );
  }

  finalizarRecadastramento(recadastramento: FinalizarRecadastramentoRequestDto): Observable<FinalizarRecadastramentoResponseDto> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const formData = new FormData();

    // Obter recadastroId do localStorage
    const recadastramentoAtivo = localStorage.getItem('recadastramentoAtivo');
    const dadosRecadastramento = recadastramentoAtivo ? JSON.parse(recadastramentoAtivo) : null;

    // Tentar obter o recadastroId do localStorage
    const recadastroIdDoStorage = dadosRecadastramento?.recadastroId;

    // Verificar se temos um recadastroId válido
    if (!recadastroIdDoStorage) {
      console.error('❌ Erro: Não foi encontrado um recadastroId válido para finalização');
      throw new Error('Não foi possível encontrar o ID do recadastramento para finalização');
    }

    formData.append('RecadastroId', dadosRecadastramento.cadastroId || recadastramento.recadastroId);


    formData.append('LatitudeFim', recadastramento.latitudeFim);
    formData.append('LongitudeFim', recadastramento.longitudeFim);


    // Nova URL com recadastroId no path
    const url = `${environment.cedaeapp}/recadastro/finalizar/${recadastroIdDoStorage}`;

    return this.httpClient.put<FinalizarRecadastramentoResponseDto>(url, formData, { headers }).pipe(
      tap(response => {
        localStorage.removeItem('recadastramentoAtivo');
      }),
      catchError(err => {
        console.error('❌ Erro ao finalizar recadastramento:', err);
        throw err;
      })
    );
  }

  adicionarRecadastro(recadastroId: string, usuarioId: string, formData?: any): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    console.log('ℹ️ Usando recadastroId:', recadastroId);

    let requestData = new FormData();

    // Always include the UserId
    requestData.append('UsuarioId', usuarioId);

    // Try to get original data to preserve admin fields
    const rawData = localStorage.getItem('fichaFormDataRaw');

    // Process FormData object
    if (formData instanceof FormData) {
      // Get FormData entries
      const formEntries = Array.from(formData.entries());

      for (const [key, value] of formEntries) {
        // Skip null values
        if (value === null || value === undefined) continue;

        // Skip photos
        if (key.includes('Fotos') || key.toLowerCase().includes('foto')) continue;

        // Ensure field capitalization is consistent
        const formattedKey = key.charAt(0).toUpperCase() + key.slice(1);

        requestData.append(formattedKey, value as string | Blob);
      }
    }
    // Process regular object
    else if (formData && typeof formData === 'object') {
      // ...existing code for processing regular objects...
    }


    const url = `${environment.cedaeapp}/recadastro/atualizar/${recadastroId}`;

    return this.httpClient.put<any>(url, requestData, { headers }).pipe(
      tap(async (response) => {


        // Upload assinatura do vistoriador
        const assinaturaVistFile = formData.get('AssinaturaVistoriante') as File;
        if (assinaturaVistFile) {
          await firstValueFrom(this.uploadAssinaturaVistoriante(recadastroId, assinaturaVistFile));

        }

        // Upload assinatura do acompanhante
        const assinaturaAcompFile = formData.get('AssinaturaAcompanhante') as File;
        if (assinaturaAcompFile) {
        }
      }),
      catchError(err => {
        console.error('❌ Erro ao atualizar cadastro:', err);
        throw err;
      })
    );
  }

  consultarRealizadasPorUsuarioId(usuarioId: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const url = `${environment.cedaeapp}/buscasdetalhadas/usuarios/${usuarioId}/registros-do-dia`;

    return this.httpClient.get<any>(url, { headers }).pipe(
      tap(response => console.log('✅ consumidor:', response)),
      catchError(err => {
        console.error('❌ Erro ao consultar consumidor:', err);
        throw err;
      })
    );
  }
}